import React from 'react';

export const Question = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8 0C3.58854 0 0 3.58854 0 8C0 12.4115 3.58854 16 8 16C12.4115 16 16 12.4115 16 8C16 3.58854 12.4115 0 8 0ZM8 1.33333C11.6901 1.33333 14.6667 4.3099 14.6667 8C14.6667 11.6901 11.6901 14.6667 8 14.6667C4.3099 14.6667 1.33333 11.6901 1.33333 8C1.33333 4.3099 4.3099 1.33333 8 1.33333Z"
                fill="#C1C4C9"
            />
            <path
                d="M8.00016 4.05371C6.53402 4.05371 5.3335 5.25423 5.3335 6.72038H6.66683C6.66683 5.97559 7.25537 5.38704 8.00016 5.38704C8.74496 5.38704 9.3335 5.97559 9.3335 6.72038C9.3335 7.23079 9.00537 7.68392 8.521 7.84538L8.25016 7.92871C7.70589 8.1084 7.3335 8.62923 7.3335 9.19954V10.0537H8.66683V9.19954L8.93766 9.11621C9.96371 8.77506 10.6668 7.80111 10.6668 6.72038C10.6668 5.25423 9.46631 4.05371 8.00016 4.05371ZM7.3335 10.7204V12.0537H8.66683V10.7204H7.3335Z"
                fill="#C1C4C9"
            />
        </svg>
    );
};
